export const CablewayLoader = ({ size = "md", text = "Loading..." }) => {
  const dims = { sm: 40, md: 72, lg: 140, xl: 180 };
  const d = dims[size] || 72;

  return (
    <div className="flex flex-col items-center justify-center gap-4" data-testid="cableway-loader">
      <svg width={d * 2} height={d} viewBox="0 0 140 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Cable line going up */}
        <line x1="5" y1="52" x2="130" y2="10" stroke="hsl(var(--primary))" strokeWidth="1.5" strokeLinecap="round" opacity="0.3" />

        {/* Mountain silhouette */}
        <path d="M0 60 L30 32 L45 42 L70 18 L90 28 L125 6 L140 60 Z" fill="hsl(var(--primary))" opacity="0.06" />
        <path d="M0 60 L30 32 L45 42 L70 18 L90 28 L125 6" stroke="hsl(var(--primary))" strokeWidth="1" opacity="0.12" fill="none" />

        {/* Cable car (gondola) moving up the line */}
        <g className="animate-cableway-ride">
          {/* Cable attachment */}
          <line x1="0" y1="-2" x2="0" y2="7" stroke="hsl(var(--primary))" strokeWidth="1.5" />
          {/* Gondola body */}
          <rect x="-9" y="7" width="18" height="11" rx="2" fill="hsl(var(--primary))" opacity="0.9" />
          {/* Windows */}
          <rect x="-6" y="9.5" width="4.5" height="5" rx="0.5" fill="hsl(var(--background))" opacity="0.5" />
          <rect x="1.5" y="9.5" width="4.5" height="5" rx="0.5" fill="hsl(var(--background))" opacity="0.5" />
        </g>

        {/* Peak marker */}
        <circle cx="130" cy="10" r="3" fill="hsl(var(--primary))" opacity="0.4">
          <animate attributeName="opacity" values="0.2;0.7;0.2" dur="2.5s" repeatCount="indefinite" />
        </circle>
      </svg>

      {text && (
        <p className="text-sm text-muted-foreground animate-pulse font-medium tracking-wide">
          {text}
        </p>
      )}
    </div>
  );
};

export const PageLoader = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-background z-50">
    <CablewayLoader size="xl" text="Loading Cableway Finance..." />
  </div>
);

export const CardLoader = () => (
  <div className="flex items-center justify-center py-12">
    <CablewayLoader size="md" text="Fetching data..." />
  </div>
);
